import React from 'react';
import SectionMenuLayout, { activeSubsection } from 'components/quote_builder_widget/shared/SectionMenuLayout';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const CUSTOMER_SECTIONS = [
  { id: 'customer_contact', label: 'quote_builder_widget.customer_menu_contact' },
  { id: 'customer_two_factor', label: 'quote_builder_widget.customer_menu_two_factor' },
];

// The code goes to a field the customer fills in, so each needs the widget to ask for it
// (UserQuoteBuilderWidget::CUSTOMER_TWO_FACTOR_ASKED_FIELDS).
const TWO_FACTOR_OPTIONS = [
  { value: '', label: 'quote_builder_widget.customer_two_factor_none' },
  { value: 'sms', label: 'quote_builder_widget.customer_two_factor_sms', askedField: 'phone', hint: 'quote_builder_widget.customer_two_factor_sms_needs_phone' },
  { value: 'email', label: 'quote_builder_widget.customer_two_factor_email', askedField: 'email', hint: 'quote_builder_widget.customer_two_factor_email_needs_email' },
];

const CustomerSection = ({
  activeSection,
  onSectionChange,
  askCustomerEmail,
  setAskCustomerEmail,
  askCustomerPhone,
  setAskCustomerPhone,
  customerTwoFactor,
  setCustomerTwoFactor,
}) => {
  const active = activeSubsection(CUSTOMER_SECTIONS, activeSection);
  const asked = { email: askCustomerEmail, phone: askCustomerPhone };

  // A field no longer asked for cannot receive the code.
  const changeAskCustomerEmail = (value) => {
    setAskCustomerEmail(value);
    if (!value && customerTwoFactor === 'email') {
      setCustomerTwoFactor('');
    }
  };

  const changeAskCustomerPhone = (value) => {
    setAskCustomerPhone(value);
    if (!value && customerTwoFactor === 'sms') {
      setCustomerTwoFactor('');
    }
  };

  return (
    <SectionMenuLayout
      label={t('quote_builder_widget.section_customer')}
      sections={CUSTOMER_SECTIONS}
      activeId={active.id}
      onSectionChange={onSectionChange}
    >
      {active.id === 'customer_contact' && (
        <div className={styles.fieldGroup}>
          <label className={styles.label}>{t('quote_builder_widget.customer_menu_contact')}</label>
          <p className={styles.helpText}>{t('quote_builder_widget.customer_contact_information')}</p>
          <div className="checkbox">
            <label>
              <input type="checkbox" checked={askCustomerEmail} onChange={(event) => changeAskCustomerEmail(event.target.checked)} />
              {' '}{t('quote_builder_widget.ask_customer_email')}
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input type="checkbox" checked={askCustomerPhone} onChange={(event) => changeAskCustomerPhone(event.target.checked)} />
              {' '}{t('quote_builder_widget.ask_customer_phone')}
            </label>
          </div>
        </div>
      )}

      {active.id === 'customer_two_factor' && (
        <div className={styles.fieldGroup}>
          <label className={styles.label}>{t('quote_builder_widget.customer_menu_two_factor')}</label>
          <p className={styles.helpText}>{t('quote_builder_widget.customer_two_factor_information')}</p>
          {TWO_FACTOR_OPTIONS.map((option) => {
            const unavailable = option.askedField !== undefined && !asked[option.askedField];
            return (
              <div className={unavailable ? 'radio disabled' : 'radio'} key={option.value || 'none'}>
                <label>
                  <input
                    type="radio"
                    name="customer_two_factor"
                    value={option.value}
                    checked={customerTwoFactor === option.value}
                    disabled={unavailable}
                    onChange={() => setCustomerTwoFactor(option.value)}
                  />
                  {' '}{t(option.label)}
                </label>
                {unavailable && <p className={styles.helpText}>{t(option.hint)}</p>}
              </div>
            );
          })}
        </div>
      )}
    </SectionMenuLayout>
  );
};

export default CustomerSection;
